var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoClubChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.23 53.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#142a38;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#3aaf50;}.cls-3{font-size:6.18px;fill:#b1bfd4;font-family:Montserrat-Regular, Montserrat;letter-spacing:0.2em;}.cls-4{letter-spacing:0.18em;}.cls-5{letter-spacing:0.19em;}.cls-6{letter-spacing:0.2em;}.cls-7{letter-spacing:0.19em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.81,25.19l-.08-.08-2.08-2,.08-.09a9.19,9.19,0,0,0,2.38-5.44V17a9.12,9.12,0,0,0-2.42-6.12c-.29,6.67-6.57,11.94-14.56,12.1H30a13.66,13.66,0,0,0,10.1,4.38H51.81a1.29,1.29,0,0,0,1-2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.82,0c-7,0-12.72,4.53-12.72,10.37v.29l0,.33a9.24,9.24,0,0,0,2.37,5.44l.09.1-2.08,2-.08.09a1.29,1.29,0,0,0,1,2.14H36.13C43,20.6,48.55,16.12,48.55,10.37S42.81,0,35.82,0ZM37.7,13.82h-8a1.29,1.29,0,0,1-.13-2.58h8a1.3,1.3,0,0,1,.12,2.59Zm3.51-3.46H29.68a1.3,1.3,0,0,1-.13-2.59H41.09a1.29,1.29,0,0,1,.12,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.5,34.66v1.93a4.48,4.48,0,0,0-2.91-1.18,3.68,3.68,0,0,0-2.8,1.19,4,4,0,0,0-1.15,2.9,3.93,3.93,0,0,0,1.15,2.87,3.78,3.78,0,0,0,2.8,1.16,3.4,3.4,0,0,0,1.46-.28,4.78,4.78,0,0,0,.7-.37,6.94,6.94,0,0,0,.75-.58v2a5.9,5.9,0,0,1-2.93.78,5.38,5.38,0,0,1-3.94-1.61A5.32,5.32,0,0,1,0,39.52a5.49,5.49,0,0,1,1.36-3.67,5.42,5.42,0,0,1,4.34-2,5.43,5.43,0,0,1,2.8.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.18 34.08 12.18 43.33 15.35 43.33 15.35 44.86 10.56 44.86 10.56 34.08 12.18 34.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.19,34.08v6.49a3.56,3.56,0,0,0,.46,2,2.21,2.21,0,0,0,1.9.93,2.23,2.23,0,0,0,1.92-.93,3.52,3.52,0,0,0,.45-2V34.08h1.63V41a4,4,0,0,1-6.92,2.81A3.9,3.9,0,0,1,16.57,41V34.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.13,44.86V34.08h1.62a6.61,6.61,0,0,1,1.72.17,2.61,2.61,0,0,1,1.1.56,3.21,3.21,0,0,1,1,2.29,2.55,2.55,0,0,1-.88,2,2.56,2.56,0,0,1,1.35,1,3,3,0,0,1,.5,1.69,2.88,2.88,0,0,1-.89,2.14,2.92,2.92,0,0,1-1.21.75,7.27,7.27,0,0,1-1.84.2Zm1.63-6.15h.51a1.92,1.92,0,0,0,1.33-.4A1.58,1.58,0,0,0,31,37.12,1.51,1.51,0,0,0,30.59,36a1.78,1.78,0,0,0-1.26-.4h-.57Zm0,4.62h1a2.47,2.47,0,0,0,1.62-.43,1.48,1.48,0,0,0,.55-1.19,1.5,1.5,0,0,0-.53-1.17,2.71,2.71,0,0,0-1.82-.47h-.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.93 36.45 73.93 44.85 71.12 44.85 71.12 36.45 68.82 36.45 68.82 34.07 76.23 34.07 76.23 36.45 73.93 36.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.7,37.67a3,3,0,0,0-2.4-1.18,2.84,2.84,0,0,0-1.17.23,2.93,2.93,0,0,0-.92.62,2.78,2.78,0,0,0-.61.94,3.25,3.25,0,0,0,0,2.35,2.89,2.89,0,0,0,1.54,1.58,2.87,2.87,0,0,0,1.14.23,3.25,3.25,0,0,0,2.42-1.15v3.32l-.29.1a9.19,9.19,0,0,1-1.2.34,5.92,5.92,0,0,1-1.1.1,5.59,5.59,0,0,1-3.94-1.61,6,6,0,0,1-1.25-1.81,5.63,5.63,0,0,1-.47-2.3A5.64,5.64,0,0,1,40,34.19a5.62,5.62,0,0,1,2.16-.42,5.86,5.86,0,0,1,1.26.14,7.6,7.6,0,0,1,1.31.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.73 38.23 53.78 38.23 53.78 34.07 56.58 34.07 56.58 44.85 53.78 44.85 53.78 40.41 49.73 40.41 49.73 44.85 46.93 44.85 46.93 34.07 49.73 34.07 49.73 38.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.45,43h-4l-.64,1.87h-3l4.11-10.78H65l4.1,10.78h-3Zm-.75-2.13-1.25-3.59-1.26,3.59Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(0 51.9)"
  }, "P", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 5.67,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 11.96,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 19.97,
    y: 0
  }, "ERED "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 45.6,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 51.4,
    y: 0
  }, "Y L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 64.29,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 70.56,
    y: 0
  }, "A"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClubChat);
export default __webpack_public_path__ + "static/media/logo_club_chat.fb53b08629f46b85eba18c4d16362550.svg";
export { ForwardRef as ReactComponent };